export default __webpack_public_path__ + "f8d3f32486a2b5f4fcd6111a1f504d15.svg";